import type { Ticket } from '@catalyst-psa/shared';

/**
 * The user-facing ticket identifier. When a ticket has a ClickUp custom ID (e.g. "CST-4021")
 * that is shown as the primary reference; otherwise (project/legacy tickets) it falls back to
 * the numeric `#number`.
 */
export function ticketDisplayId(
  ticket: Pick<Ticket, 'referenceId' | 'number'>,
): string {
  const reference = ticket.referenceId?.trim();
  return reference ? reference : `#${ticket.number}`;
}

/**
 * Loose variant for display contexts that only carry a nullable reference + number (e.g.
 * time-entry rows). Support tickets show the ClickUp custom ID; project/legacy tickets and
 * charge codes fall back to `#number`, or a dash when there is no ticket at all.
 */
export function ticketRefLabel(
  referenceId: string | null | undefined,
  number: number | null | undefined,
): string {
  const reference = referenceId?.trim();
  if (reference) return reference;
  return number != null ? `#${number}` : '—';
}
